export class ByPassValidationInnerType {}
